// アプリケーションの基本CSS
import '@/stylesheets/application.scss'

console.log('Vite + Rails application loaded')